var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTickCircled = function SvgTickCircled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 200 200",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: -0.34,
    y1: 100.04,
    x2: 199.66,
    y2: 100.04,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3d43c1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a80096"
  })))), /*#__PURE__*/React.createElement("path", {
    d: "M199.66,100.04c0,19.74-5.86,38.93-16.94,55.51-1.51,2.25-3.98,3.47-6.5,3.47-1.49,0-3-.43-4.34-1.32-3.59-2.4-4.55-7.25-2.15-10.84,9.36-14,14.31-30.19,14.31-46.83,0-7.15-.89-14.25-2.66-21.1-1.08-4.18,1.44-8.44,5.62-9.51,4.18-1.07,8.44,1.44,9.51,5.62,2.09,8.12,3.15,16.53,3.15,25ZM143.31,172.27c-13.12,7.95-28.22,12.15-43.65,12.15-46.52,0-84.37-37.85-84.37-84.37S53.14,15.67,99.66,15.67c17.23,0,33.79,5.15,47.9,14.91,3.55,2.45,8.42,1.56,10.87-1.99,2.45-3.55,1.56-8.42-1.99-10.87C139.71,6.16,120.07.04,99.66.04,72.95.04,47.84,10.44,28.95,29.33,10.06,48.22-.34,73.33-.34,100.04s10.4,51.82,29.29,70.71c18.89,18.89,44,29.29,70.71,29.29,18.29,0,36.18-4.98,51.74-14.41,3.69-2.24,4.87-7.04,2.64-10.73-2.24-3.69-7.04-4.87-10.73-2.63ZM100.41,122.7c-1.24.05-2.39-.39-3.29-1.25l-40.92-38.8c-3.13-2.97-8.08-2.84-11.04.29-2.97,3.13-2.84,8.08.29,11.04l40.91,38.79c3.78,3.59,8.67,5.54,13.84,5.54.28,0,.56,0,.83-.02,5.49-.22,10.52-2.6,14.19-6.69.09-.1.18-.21.27-.32L197.93,28.77c2.7-3.36,2.17-8.28-1.19-10.98-3.36-2.7-8.28-2.17-10.98,1.19l-82.28,102.34c-.81.84-1.89,1.33-3.07,1.38Z",
    style: {
      fill: "url(#b)",
      strokeWidth: 0
    }
  }));
};
export default SvgTickCircled;